import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import LookupOverview from './LookupOverview';
import RevenueCardList from './RevenueCardList';

const RevenueHeader = () => {
  return (
    <Page title='Logirate | Revenue Header'>
      <PageLayout>
        <Container>
          <LookupOverview />
          <RevenueCardList />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default RevenueHeader;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
